import classnames from 'classnames';

import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';
import { isB2B } from '@/domains/core/settings/utils';

import styles from './outlineBundleProductCard.module.scss';

const OutlineBundleProductCardSkel = () => (
  <div
    className={styles.wrapper}
    data-testid="outline-bundle-product-card-skel-wrapper"
  >
    <div className={styles.imageWrapper}>
      <Skeleton className={styles.imageSkel} />
    </div>

    <div className={styles.infoWrapper}>
      <div className={styles.textWrapperSkel}>
        <Skeleton
          className={classnames(styles.title, styles.titleSkel)}
          type="paragraph"
        />
        <Skeleton
          className={classnames(styles.title, styles.titleSkel)}
          type="paragraph"
        />
        <Skeleton
          className={classnames(styles.title, styles.titleSkel)}
          type="paragraph"
        />

        {!isB2B() && (
          <div data-testid="outline-bundle-product-card-skel-extraLine">
            <Skeleton
              className={classnames(styles.title, styles.titleSkel)}
              type="paragraph"
            />
          </div>
        )}
      </div>

      <div className={styles.priceWrapperSkel}>
        <Skeleton
          className={classnames(styles.title, styles.titleSkel)}
          type="paragraph"
          width="50px"
          height="18px"
        />
        {isB2B() && (
          <div data-testid="outline-bundle-product-card-skel-vatLine">
            <Skeleton type="paragraph" className={styles.priceVatSkel} />
          </div>
        )}
      </div>
    </div>
  </div>
);

OutlineBundleProductCardSkel.displayName = 'OutlineBundleProductCardSkel';

export default OutlineBundleProductCardSkel;
